export function compareArraysFast(arr1, arr2) {
  if (arr1.length !== arr2.length) return false; // Early exit for different lengths

  const freq1 = new Map();
  for (const element of arr1) {
    freq1.set(element, (freq1.get(element) || 0) + 1);
  }

  for (const element of arr2) {
    if (!freq1.has(element) || freq1.get(element) === 0) {
      return false;
    }
    freq1.set(element, freq1.get(element) - 1); // Decrement frequency in arr1
  }

  return true;
}
